<script lang="ts">
  import type { LeaderboardRank, LeaderboardSkillsDetail as StudentClassLeaderboard } from '$lib/api/types';
  import Loading from '$lib/components/Loading.svelte';
  import Leaderboard from '$lib/components/student/Leaderboard.svelte';
  import { onMount } from 'svelte';
  import type { PageProps } from './$types';
  import { invalidate } from '$app/navigation';

  let { data, params }: PageProps = $props();

  let studentRanks: LeaderboardRank[] | null = $state(null);
  let studentClassInfo: StudentClassLeaderboard | null = $state(null);
  let updatedTime: string | null = $state(null);
  let isLoading = $state(true);

  $effect(() => {
    Promise.all([data.leaderboardPromise, data.classPromise]).then(([ranks, clazz]) => {
      studentRanks = ranks;
      studentClassInfo = clazz;
      isLoading = false;
      updatedTime = new Date().toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
    });
  });

  onMount(() => {
    const interval = setInterval(
      () => {
        isLoading = true;
        invalidate(url => url.pathname === `/api/studentactions/classes/${params.id}/leaderboard`);
      },
      // 3000,
      120_000,
    ); // update every 2 minutes

    return () => {
      clearInterval(interval);
    };
  });
</script>

{#if studentRanks === null || studentClassInfo === null}
  <Loading />
{:else}
  <Leaderboard rankings={studentRanks} {studentClassInfo} {isLoading} {updatedTime} />
{/if}
